<template>
    <div>
		<Spinner size="huge" v-if="!idle"></Spinner>
		<section class="latest-readings" v-if="idle">
			<div class="readings-header">
				<header class="card-header">
					<p class="card-header-title">
						Readings
					</p>
				</header>
				<div class="columns">
					<div class="column">
						<h4>Summary</h4>
						<ul>
							<li><span>Total:</span> {{ summary.totCalls }}</li>
							<li><span>Repeat:</span> {{ summary.repCalls }}</li>
							<li><span>Free Minutes:</span> {{ summary.freeMins }}</li>
							<li><span>Total Minutes:</span> {{ summary.totMins }}</li>
							<li><span>Repeat Minutes:</span> {{ summary.repMins }}</li>
							<li><span>Repeat Pct:</span> {{ summary.repPct }}%</li>
							<li><span>Missed:</span> {{ summary.missCalls }}</li>
							<li><span>ALC:</span> {{ summary.alc }}</li>
						</ul>
					</div>
				</div>
			</div>
					<div class="column">
						<div class="columns refine">
							<DatePicker 
								:startDate="startDate" 
								:endDate="endDate"
								@startDateInput="updateStartDate"
								@endDateInput="updateEndDate"
								@enter="updateData" />
							<div class="column is-7">
								<div class="columns refine is-mobile">
									<div class="column">
										<div class="field">
											<div class="control">
												<a class="button is-primary is-small" @click="updateData">
												Update </a>
											</div>
										</div>
									</div>
								<div class="column">
									<PageSize v-model="pageSize" @input="$refs.paginator.goToPage(0)" />
								</div>
								</div>
							</div>
						</div>
					</div>
			<div class="card-table">
				<div class="table-container">
					<table id="allPsychics" class="table is-striped is-narrow is-fullwidth">
						<thead>
							<tr>
								<th class="is-hidden-mobile" v-if="!limited">
									<a @click="sortReading('connID')">Id</a>
								</th>
								<th>
									<a @click="sortReading('date')">Date</a>
								</th>
								<th>
									<a @click="sortReading('custUserName')">Member</a>
								</th>
								<th class="is-hidden-mobile">
									<a @click="sortReading('type')">New or<br />
									Repeat</a>
								</th>
								<th class="is-hidden-mobile">
									<a @click="sortReading('mins')">Dur. (Mins)</a>
								</th>
								<th class="is-hidden-mobile">
									<a @click="sortReading('freeMins')">Free Mins.</a>
								</th>
								<th class="is-hidden-mobile">
									<a @click="sortReading('paidMins')">Paid Mins.</a>
								</th>
								<th class="is-hidden-mobile" v-if="!limited">
									<a @click="sortReading('rate')">Rate</a>
								</th>
								<th v-if="!limited">
									<a @click="sortReading('revenue')">Call Rev.</a>
								</th>
								<th class="is-hidden-mobile">
									<a @click="sortReading('result')">Results</a>
								</th>
								<th class="is-hidden-mobile">
									<a @click="sortReading('rating')">Rating</a>
								</th>
								<th class="is-hidden-mobile">
									<a @click="sortReading('rating')">Rat. Text</a>
								</th>
								<th v-if="!limited">
									Play Call
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(reading, idx) in paginatedData" :key="idx">
								<td class="is-hidden-mobile" v-if="!limited">
									<a v-if="!limited && reading.has_recording" @click="audioReading = reading">{{ reading.connID }}</a>
									<span v-if="limited || !reading.has_recording">{{ reading.connID }} </span>
								</td>
								<td class="">{{ formatReadingDate(reading.date) }}</td>
								<td class="member-name">{{ reading.custUserName }}</td>
								<td class="is-hidden-mobile">{{ reading.type }}</td>
								<td class="is-hidden-mobile">{{ reading.mins }}</td>
								<td class="is-hidden-mobile">{{ reading.freeMins }}</td>
								<td class="is-hidden-mobile">{{ reading.paidMins }}</td>
								<td class="is-hidden-mobile" v-if="!limited">${{ reading.rate }}</td>
								<td class="" v-if="!limited">{{ reading.revenue }}</td>
								<td class="is-hidden-mobile">{{ reading.result }}</td>
								<td class="is-hidden-mobile">{{ reading.rating }}</td>
								<td class="is-hidden-mobile">
									<button class="button is-info is-small" @click="showModal(reading)" v-if="reading.rating != null">
										<i class="fa fa-eye"></i>
									</button>
								</td>
								<td class="" v-if="!limited"><button class="button is-info is-small" v-if="reading.has_recording" @click="audioReading = reading"><i class="fa fa-play"></i></button></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<Paginator ref="paginator" :itemCount="this.readings.length" :pageSize="this.pageSize" v-model="pageNumber" />
		</section>	
		<Modal v-if="audioReading != null" @close="audioReading = null">
			<span slot="title">LISTEN TO CALL ID {{ audioReading.connID }}</span>
			<div class="columns" slot="body">
				<div class="column">
					<div class="card">
						<div class="card-table">
							<div class="content">
								<audio controls>
									<source :src="audioPath" type="audio/wav">
									Your browser does not support the audio element. 
								</audio>
							</div>
							<div class="content">
								<a :href="audioPath" target="_blank">Download</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
		<Modal v-if="ratingModalOpen" @close="ratingModalOpen = false">
			<span slot="title">Rating text from {{ selectedReading.custUserName }}</span>
			<div slot="body">
				<p class="modal-date">{{ formatReadingDate(selectedReading.date) }}</p>
				<p class="modal-p">{{ selectedReading.ratingText }}</p>
			</div>
		</Modal>
    </div>
</template>

<script>
	import moment from "moment-timezone"

	import Paginator from "../Paginator.vue"
	import PageSize from "../PageSize.vue"
	import DatePicker from "../DatePicker.vue"
	import Modal from "../Modal.vue"
	import Spinner from 'vue-simple-spinner'

	export default {
		components: {
			Paginator,
			PageSize,
			DatePicker,
			Modal,
			Spinner
        },
        props: {
            id: String,
            limited: Boolean
        },
		data() {
			return {
				audioReading: null,
				pageNumber: 0,
				pageSize: 10,
				readings: [],
				summary: {},
				startDate: moment(Date.now()).add(-7, 'days').valueOf().toString(),
				endDate: Date.now().toString(),
				selectedReading: {},
				ratingModalOpen: false,
				sortCol: "date",
				sortDir: -1,
				idle: false
			}
		},
		methods: {
			formatReadingDate(date) {
				return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY hh:mm:ss A")
			},
			calcRev(reading) {
				return reading.paidMins * reading.rate
			},
			updateStartDate(date) {
				this.startDate = moment(date).valueOf().toString()
			},
			updateEndDate(date) {
				this.endDate = moment(date).valueOf().toString()
			},
			async updateData() {
				this.idle = false
				const readings_data = await this.$root.$data.getters.getReadings(this.$root.$data.state, this.id, this.startDate, this.endDate)
				this.readings = readings_data.readings
				this.summary = readings_data.summary
				this.idle = true
			},
			showModal(reading) {
				this.selectedReading = reading
				this.ratingModalOpen = true
			},
			sortReading(col) {
				if (this.sortCol === col) {
					this.sortDir = this.sortDir === -1 ? 1 : -1
				} else {
					this.sortCol = col
					this.sortDir = -1
				}
			}
		},
		computed: {
			audioPath() {
				if (this.audioReading != null && this.audioReading.has_recording) {
					const date = moment(this.audioReading.date).format("YYYYMMDD")
					return `${this.$root.$data.state.baseApiUri}/psychics/${this.id}/recordings/${date}/${this.audioReading.connID}`
				}
				return ""
			},
			paginatedData() {
				const start = this.pageNumber * this.pageSize,
					end = start + this.pageSize

				return this.sortedReadings.slice(start, end)
			},
			sortedReadings() {
				let sorted = this.readings
				return sorted.sort((a, b) => {
					if (a[this.sortCol] < b[this.sortCol]) return -1 * this.sortDir
					if (a[this.sortCol] > b[this.sortCol]) return 1 * this.sortDir
					return 0
				})
			}
		},
		async created() {
			this.startDate = this.$root.$data.state.payStart.valueOf().toString()
			this.endDate = this.$root.$data.state.payEnd.valueOf().toString()
			const readings_data = await this.$root.$data.getters.getReadings(this.$root.$data.state, this.id, this.startDate, this.endDate)
			console.log(readings_data)
			this.readings = readings_data.readings
			this.summary = readings_data.summary
			this.idle = true
		}
	}
</script>